import { getCurrencySymbol } from "./Utils";

export const Currencies = [
  { key: 0, text: getCurrencySymbol("USD"), value: "USD", description: "US Dollar" },
  { key: 1, text: getCurrencySymbol("EUR"), value: "EUR", description: "Euro" },
  { key: 2, text: getCurrencySymbol("CAD"), value: "CAD", description: "Canadian dollar" },
  { key: 3, text: getCurrencySymbol("JPY"), value: "JPY", description: "Japanese yen" },
  { key: 4, text: getCurrencySymbol("GBP"), value: "GBP", description: "Pound sterling" },
  { key: 5, text: getCurrencySymbol("AUD"), value: "AUD", description: "Australian dollar" },
  { key: 6, text: getCurrencySymbol("CNY"), value: "CNY", description: "Chinese Yuan (Renminbi)" },
  { key: 7, text: getCurrencySymbol("KRW"), value: "KRW", description: "South Korean won" },
  { key: 8, text: getCurrencySymbol("MXN"), value: "MXN", description: "Mexican peso" },
  { key: 9, text: getCurrencySymbol("HKD"), value: "HKD", description: "Hong Kong dollar" },
  { key: 10, text: getCurrencySymbol("SGD"), value: "SGD", description: "Singapore dollar" },
  { key: 11, text: getCurrencySymbol("TWD"), value: "TWD", description: "New Taiwan dollar" },
  { key: 12, text: getCurrencySymbol("NZD"), value: "NZD", description: "New Zealand dollar" },
  { key: 13, text: getCurrencySymbol("INR"), value: "INR", description: "Indian Rupee" },
  { key: 14, text: getCurrencySymbol("DKK"), value: "DKK", description: "Danish krone" },
  { key: 15, text: getCurrencySymbol("NOK"), value: "NOK", description: "Norwegian krone" },
  { key: 16, text: getCurrencySymbol("SEK"), value: "SEK", description: "Swedish krona" },
  { key: 17, text: getCurrencySymbol("ILS"), value: "ILS", description: "Israeli new shekel" },
  { key: 18, text: getCurrencySymbol("PLN"), value: "PLN", description: "Polish Zloty" },
  { key: 19, text: getCurrencySymbol("CHF"), value: "CHF", description: "Swiss Franc" },
  { key: 20, text: getCurrencySymbol("CZK"), value: "CZK", description: "Czech Koruna" },
  { key: 21, text: getCurrencySymbol("HUF"), value: "HUF", description: "Hungarian Forint" },
  { key: 22, text: getCurrencySymbol("RON"), value: "RON", description: "Romanian Leu" },
  { key: 23, text: getCurrencySymbol("ZAR"), value: "ZAR", description: "South African Rand" },
  { key: 24, text: getCurrencySymbol("MYR"), value: "MYR", description: "Malaysian Ringgit" },
  { key: 25, text: getCurrencySymbol("THB"), value: "THB", description: "Thai Baht" },
  { key: 26, text: getCurrencySymbol("PHP"), value: "PHP", description: "Philippine peso" },
];
